export const fillParamAdvanceSearchEmpty = (stateAdvanceSearch) => {
  const sentiment =
    stateAdvanceSearch.sentiment?.length > 0
      ? stateAdvanceSearch.sentiment
      : ['positive', 'negative', 'neutral'];
  const postOwnership =
    stateAdvanceSearch.postOwnership?.length > 0
      ? stateAdvanceSearch.postOwnership
      : ['postmade', 'talk', 'reply'];
  const contentTypeList =
    stateAdvanceSearch.contentTypeList?.length > 0
      ? stateAdvanceSearch.contentTypeList
      : [
          'text',
          'image',
          'video',
          'others',
          'carousel_with_image',
          'carousel_with_video'
        ];
  const validationList =
    stateAdvanceSearch.validationList?.length > 0
      ? stateAdvanceSearch.validationList
      : ['validated', 'unvalidated'];
  const validationEmotionList =
    stateAdvanceSearch.validationEmotionList?.length > 0
      ? stateAdvanceSearch.validationEmotionList
      : ['validated', 'unvalidated'];
  return {
    ...stateAdvanceSearch,
    sentiment,
    postOwnership,
    contentTypeList,
    validationList,
    validationEmotionList
  };
};
